import styles from './NumericIcon.module.scss'

export default function NumericIcon({number}) {
  return (
    <span className={`${styles.number} text-muted`}>{number}.</span>
  )
}
